import ModalView from './ModalView'
import {ModalViewProps} from './types'
import React from 'react'


const Modal = (props: ModalViewProps): React.ReactElement => <ModalView {...props} />
export default Modal
